// client/src/components/EditPOI_parts/EditPOI_utils.js
export function padHexColour(hex) {
  if (hex == null) return '#000000';
  if (typeof hex === 'number') return '#' + hex.toString(16).padStart(6, '0');
  let s = String(hex).trim();
  if (!s.startsWith('#')) s = '#' + s;
  if (s.length === 4) return '#' + s[1] + s[1] + s[2] + s[2] + s[3] + s[3];
  return s.length === 7 ? s : '#000000';
}

export function hexToInt(hex) {
  const h = padHexColour(hex);
  return parseInt(h.slice(1), 16);
}

export async function fetchJSON(url, opts = {}) {
  const res = await fetch(url, { credentials: 'include', ...opts });
  let body = null;
  try {
    body = await res.json();
  } catch {}
  if (!res.ok) {
    const msg = body?.error || body?.message || `${res.status} ${res.statusText}`;
    const e = new Error(msg);
    e.status = res.status;
    e.body = body;
    throw e;
  }
  return body;
}
